import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PageListStat {
    key: string;
    label: string;
    value: number | string;
    dotClass?: string;
    color?: string;
}

export interface PageListTab {
    key: string;
    label: string;
}

@Component({
    standalone: false,
    selector: 'app-page-list',
    templateUrl: './page-list.component.html',
    styleUrl: './page-list.component.scss'
})
export class PageListComponent {
    @Input() pageTitle: string = '';

    /** Optional stats line shown under the title (e.g. "12 total • 4 pending • 6 approved") */
    @Input() stats: PageListStat[] = [];
    @Input() totalLabel: string = 'total';
    @Input() totalValue: number | string = 0;

    /** Search */
    @Input() searchTerm: string = '';
    @Input() searchPlaceholder: string = 'Search...';

    /** Tabs */
    @Input() tabs: PageListTab[] = [];
    @Input() activeTab: string = '';
    @Input() showTabs: boolean = true;

    /** Empty state */
    @Input() emptyMessage: string = 'No records found';
    @Input() isLoading: boolean = false;

    @Output() searchChange = new EventEmitter<string>();
    @Output() tabChange = new EventEmitter<string>();

    /** Set by ngAfterContentInit when projected [stat-slot] content is provided. */
    hasStatSlot: boolean = false;

    /** Set by ngAfterContentInit when projected [toolbar-actions] content is provided. */
    hasToolbarActions: boolean = false;

    ngAfterContentInit(): void {
        this.hasStatSlot = true;
        this.hasToolbarActions = true;
    }

    onSearchInput(event: any) {
        const value = (event.target.value || '').toString();
        this.searchChange.emit(value);
    }

    selectTab(key: string) {
        this.tabChange.emit(key);
    }
}
